<div class="flex flex-col h-screen bg-white">

  <header class="brand-bar shrink-0">
    <div class="brand">Techsure</div>
    <div class="brand-right">
      <div class="help-actions hidden sm:flex" role="navigation" aria-label="Help">
        <button class="util-btn" type="button" aria-label="Quick tour" (click)="showQuickTourModal = true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" aria-hidden="true">
            <rect x="2" y="6" width="14" height="12" rx="2"></rect>
            <path d="M22 8l-6 4 6 4V8z"></path>
          </svg>
          <span class="label">Quick tour</span>
        </button>
        <button class="util-btn" type="button" aria-label="Know how to use" (click)="showHowToUseModal = true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9.5 9a2.5 2.5 0 0 1 5 0c0 1.5-2.5 2-2.5 4"></path>
            <circle cx="12" cy="17.5" r=".6" fill="currentColor" stroke="none"></circle>
          </svg>
          <span class="label">Know how to use</span>
        </button>
      </div>

      <div class="relative flex items-center">
        <button class="kebab" type="button" aria-label="More" (click)="toggleDropdown()">
          <span class="dot"></span><span class="dot"></span><span class="dot"></span>
        </button>
        <div *ngIf="isDropdownOpen"
          class="absolute right-0 top-12 bg-white text-black rounded-md shadow-lg overflow-hidden border border-gray-200 z-50 min-w-[120px]">
          <span (click)="logout()" class="block cursor-pointer px-4 py-3 text-sm hover:bg-gray-50">
            Logout
          </span>
        </div>
      </div>
    </div>
  </header>

  <section class="module-row shrink-0">
    <span class="avatar" aria-hidden="true">
      <img src="../../../../assets/icons/copilot-bot.png" alt="bot" onerror="this.src='assets/copilot-bot.png'" />
    </span>
    <div class="text">
      <div class="title-row">
        <span class="name">Co-Pilot</span>

        <div class="proc" [attr.aria-expanded]="isProcessMenuOpen">

          <button class="proc-btn" type="button" aria-haspopup="listbox" (click)="toggleProcessMenu($event)">
            <span class="lbl" *ngIf="!isProcessLoading"> {{selectedProduct?.product ? selectedProduct?.product : ''
              }}</span>
            <span class="lbl" *ngIf="isProcessLoading">Loading...</span>
            <span class="chev" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M6 9l6 6 6-6"></path>
              </svg>
            </span>
          </button>

          <div class="proc-menu" role="listbox" aria-label="Processes" *ngIf="isProcessMenuOpen">
            <div class="menu-head">Switch process</div>
            <div class="search">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" aria-hidden="true">
                <circle cx="11" cy="11" r="7"></circle>
                <path d="M21 21l-4.3-4.3"></path>
              </svg>
              <input type="text" placeholder="Search…" [(ngModel)]="processSearchQuery"
                (click)="$event.stopPropagation()" />
            </div>

            <div class="options-container" style="max-height: 220px; overflow-y: auto;">
              <div role="option" class="opt" *ngFor="let proc of filteredProcesses"
                [attr.aria-selected]="proc === selectedProduct?.product" (click)="selectProcess(proc)">
                <span class="mono" aria-hidden="true">{{ proc.substring(0, 2).toUpperCase() }}</span>
                <span class="opt-name">{{ proc }}</span>
                <svg class="check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 12l5 5L20 7"></path>
                </svg>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="tag">Ask anything. Get guidance. Take action.</div>
    </div>
  </section>

  <nav class="quick-bar shrink-0" aria-label="Quick actions">
    <span class="qa-label">
      <span class="qa-title">Common areas</span>
      <span class="qa-sub">Select relevant area (optional)</span>
    </span>

    <button class="qa" type="button" [class.is-selected]="selectedFocusArea === 'Gate Criteria'"
      (click)="toggleFocusArea('Gate Criteria')">
      <img class="w-4 h-4 mr-1" src="../../../../assets/icons/icon-eligibility.png" alt="" />
      Gate Criteria
    </button>

    <button class="qa" type="button" [class.is-selected]="selectedFocusArea === 'Financial UW'"
      (click)="toggleFocusArea('Financial UW')">
      <img class="w-4 h-4 mr-1" src="../../../../assets/icons/icon-financial.png" alt="" />
      Financial UW
    </button>

    <button class="qa" type="button" [class.is-selected]="selectedFocusArea === 'Medical UW'"
      (click)="toggleFocusArea('Medical UW')">
      <img class="w-4 h-4 mr-1" src="../../../../assets/icons/icon-medical.png" alt="" />
      Medical UW
    </button>

    <button class="qa" type="button" [class.is-selected]="selectedFocusArea === 'Pincode List'"
      (click)="toggleFocusArea('Pincode List')">
      <img class="w-4 h-4 mr-1" src="../../../../assets/icons/icon-pincode.png" alt="" />
      Pincode List
    </button>

    <button class="qa" type="button" [class.is-selected]="selectedFocusArea === 'Help me decide'"
      (click)="toggleFocusArea('Help me decide')">
      <img class="w-4 h-4 mr-1" src="../../../../assets/icons/icon-help.png" alt="" />
      Help me decide
    </button>
  </nav>

  <main class="chat flex-1 min-h-0 p-4 overflow-y-auto bg-white" #chatContainer aria-label="Conversation">
    <div class="messages">
      <div *ngFor="let pair of messageResponsePairs, index as i" class="w-full mb-4 flex flex-col">

        <div *ngIf="pair.message"
          class="self-end max-w-64 xl:max-w-[29rem] mb-2 p-2 message rounded-md text-[12px] sm:text-sm md:text-base lg:text-lg">
          {{ pair.message }}
        </div>

        <div *ngIf="pair.loading" class="flex items-center w-full ml-1 mb-2">
          <div class="w-2 h-2 rounded-full animate-pulse loader mr-1"></div>
          <div class="w-2 h-2 rounded-full animate-pulse loader mr-1"></div>
          <div class="w-2 h-2 rounded-full animate-pulse loader"></div>
        </div>

        <div *ngIf="pair.response?.length > 0" class="w-full flex flex-col">

          <div [id]="i==messageResponsePairs.length-1?'final':''" class="w-full p-3 rounded-md border response-box">
            <p class="text-left text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug"
              [innerHTML]="pair.response[pair.currentPage]"></p>
          </div>

          <div class="flex justify-between items-center w-full mt-2 px-1">

            <div class="flex items-center gap-4">
              <div [ngClass]="{'buttonClicked': pair.isLiked}" (click)="responseLiked(pair, i)"
                class="h-8 w-8 like rounded-full p-2 rotate-180 scale-x-[-1] cursor-pointer flex justify-center items-center">
                <img class="h-4 w-4" src="../../../../assets/icons/dislike.png" />
              </div>
              <div [ngClass]="{'buttonClicked': pair.isDisliked}" (click)="showDialog(pair, i)"
                class="h-8 w-8 dislike rounded-full p-2 cursor-pointer flex justify-center items-center">
                <img class="h-4 w-4" src="../../../../assets/icons/dislike.png" />
              </div>
            </div>

            <div class="flex items-center text-sm font-medium" *ngIf="pair.totalPages > 1">
              <button (click)="previousPage(i)" [disabled]="pair.currentPage === 0"
                class="px-2 py-1 disabled:opacity-50 hover:text-blue-700 transition-colors cursor-pointer">
                &lt;
              </button>
              <span class="mx-2 text-gray-600">{{ pair.currentPage + 1 }} of {{ pair.totalPages }}</span>
              <button (click)="nextPage(i)" [disabled]="pair.currentPage === pair.totalPages - 1"
                class="px-2 py-1 disabled:opacity-50 hover:text-blue-700 transition-colors cursor-pointer">
                &gt;
              </button>
            </div>

          </div>
        </div>

      </div>
    </div>
  </main>

  <div class="composer-wrap shrink-0">
    <div class="composer" [class.is-suggesting]="suggestedItems.length > 0">

      <div class="suggest shadow-xl" *ngIf="suggestedItems.length > 0">
        <div class="suggest-head">You can ask things like</div>
        <div class="suggest-list">
          <div class="sug" *ngFor="let item of suggestedItems" (click)="selectSuggestion(item)">
            <span class="ico" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="11" cy="11" r="7"></circle>
                <path d="M21 21l-4.3-4.3"></path>
              </svg>
            </span>
            <span class="txt" [innerHTML]="highlightText(item, inputText)"></span>
          </div>
        </div>
      </div>

      <div class="input-row relative" [class.focus-within]="inputText.length > 0">
        <textarea id="input" #messageInput [(ngModel)]="inputText" (input)="onTextInput($event)"
          (keydown)="onKeyDown($event, messageInput)" placeholder="Type your message..."
          class="flex-1 border-0 bg-transparent outline-none resize-none overflow-y-auto text-base text-[#1d2530] focus:ring-0 leading-snug py-4"
          style="height: 55px; max-height: 150px;">
        </textarea>

        <div class="flex items-center gap-2 pl-2 bg-white">
          <div class="error-status-messages hidden sm:block text-right">
            <div *ngIf="isListening" class="text-[10px] sm:text-xs text-gray-500">Listening... Speak clearly.</div>
            <div *ngIf="isProcessing" class="text-[10px] sm:text-xs text-gray-500">Processing your speech ...</div>
            <div *ngIf="voiceError" class="text-[10px] sm:text-xs text-red-500">{{ voiceError }}</div>
          </div>

          <button *ngIf="isVoiceEnabled" class="mic-inline" type="button" aria-label="Voice input"
            (click)="toggleVoiceRecognition()">
            <svg *ngIf="!isListening" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="9" y="3" width="6" height="12" rx="3"></rect>
              <path d="M5 11a7 7 0 0 0 14 0"></path>
              <path d="M12 18v3"></path>
            </svg>
            <div *ngIf="isListening" class="bg-red-500 rounded-full h-4 w-4 animate-pulse"></div>
          </button>

          <button class="send shrink-0" type="button" aria-label="Send" (click)="sendMessage(messageInput)"
            [disabled]="!inputText && !isResponseLoading">
            <svg *ngIf="!isResponseLoading" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M5 12h14"></path>
              <path d="M13 6l6 6-6 6"></path>
            </svg>
            <svg (click)="stopAPI(); $event.stopPropagation();" *ngIf="isResponseLoading" viewBox="0 0 100 100"
              class="h-5 w-5" xmlns="http://www.w3.org/2000/svg">
              <rect x="20" y="20" width="20" height="60" fill="currentColor" />
              <rect x="60" y="20" width="20" height="60" fill="currentColor" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <footer class="shrink-0 bg-[#D9EAD5] py-3 px-6 flex items-center text-[10px] sm:text-xs text-gray-600">
    <span class="pwr inline-flex items-center gap-2 font-semibold text-[#1d2530]">
      <span class="logo text-[#1f6f4a]" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"
          class="w-[18px] h-[18px]">
          <path d="M21 7a9 9 0 1 0 0 10"></path>
          <path d="M17 9a5 5 0 1 0 0 6"></path>
        </svg>
      </span>
      Powered by VIGI
    </span>
    <span class="w-[1px] h-[14px] bg-black/25 inline-block mx-2"></span>
    <span class="cr text-[#2c3340]">© {{ currentYear }} CleverNav</span>
  </footer>

  <p-dialog class="dislike-dialog" [(visible)]="display">
    <div class="flex justify-between items-start">
      <div class="w-full">
        <div class="reason-buttons">
          <label
            class="block font-medium mb-2 text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug md:leading-relaxed">
            What went wrong?
          </label>
          <div class="flex reasons-checkbox gap-4">
            <div class="mr-2">
              <div class="flex items-center mb-2">
                <input type="checkbox" id="missingUpdate" [(ngModel)]="missingUpdate" (change)="getSelectedReasons()">
                <label for="missingUpdate"
                  class="ml-1 select-none text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug">Missing critical
                  update(s)</label>
              </div>
              <div class="flex items-center mb-2">
                <input type="checkbox" id="incompleteInfo" [(ngModel)]="incompleteInfo" (change)="getSelectedReasons()">
                <label for="incompleteInfo"
                  class="ml-1 select-none text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug">Incomplete
                  information</label>
              </div>
              <div class="flex items-center mb-2">
                <input type="checkbox" id="needsImprovement" [(ngModel)]="needsImprovement"
                  (change)="getSelectedReasons()">
                <label for="needsImprovement"
                  class="ml-1 select-none text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug">Needs
                  improvement</label>
              </div>
            </div>
            <div>
              <div class="flex items-center mb-2">
                <input type="checkbox" id="incorrectResponse" [(ngModel)]="incorrectResponse"
                  (change)="getSelectedReasons()">
                <label for="incorrectResponse"
                  class="ml-1 select-none text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug">Incorrect
                  response</label>
              </div>
              <div class="flex items-center mb-2">
                <input type="checkbox" id="cantUnderstand" [(ngModel)]="cantUnderstand" (change)="getSelectedReasons()">
                <label for="cantUnderstand"
                  class="ml-1 select-none text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug">Can't
                  understand</label>
              </div>
              <div class="flex items-center mb-2">
                <input type="checkbox" id="others" [(ngModel)]="others" (change)="getSelectedReasons()">
                <label for="others"
                  class="ml-1 select-none text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug">Others</label>
              </div>
            </div>
          </div>
        </div>
        <label
          class="block font-medium mt-4 ml-1 text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug md:leading-relaxed">
          Please help us understand better
        </label>
        <textarea
          class="mt-2 w-full rounded border border-gray-300 bg-white/70 text-[12px] sm:text-sm md:text-base lg:text-lg placeholder:text-[12px] sm:placeholder:text-sm md:placeholder:text-base lg:placeholder:text-lg leading-snug md:leading-relaxed pl-2 pt-2 resize-y min-h-16 max-h-40 focus:outline-none focus:ring-0 focus:border-transparent"
          [(ngModel)]="feedback" placeholder="Add more details"></textarea>
      </div>
      <div class="ml-auto">
        <button class="p-link" (click)="display=false;">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>
    <button type="button" (click)="responseDisLiked()"
      class="flex justify-center my-auto mx-auto mt-3 px-4 py-2 rounded-md bg-purple text-white hover:bg-purple/90 transition-colors text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug">
      Submit
    </button>
  </p-dialog>

  <div *ngIf="apiError" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded-lg shadow-lg text-center w-full max-w-lg">
      <p class="text-red-600 font-semibold mb-4 text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug">
        We’re experiencing a temporary issue. <br />Please refresh the page or try again later.<br />
      </p>
      <button (click)="apiError = false"
        class="bg-purple text-white px-4 py-2 rounded-md text-[12px] sm:text-sm md:text-base lg:text-lg leading-snug hover:bg-purple/90 transition-colors">
        OK
      </button>
    </div>
  </div>

</div>

<div *ngIf="showProcessChangeConfirm"
  class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
  <div class="bg-white p-6 rounded-lg shadow-xl text-center w-full max-w-sm mx-4">
    <p class="text-[#1d2530] font-semibold mb-6 text-[14px] sm:text-[16px] leading-relaxed">
      Changing the process will clear your current chat. Are you sure you want to proceed?
    </p>
    <div class="flex justify-center gap-4">
      <button (click)="cancelProcessChange()"
        class="px-6 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors text-sm font-medium">
        Cancel
      </button>
      <button (click)="confirmProcessChange()"
        class="bg-[#004b93] text-white px-6 py-2 rounded-md hover:bg-[#003a73] transition-colors text-sm font-medium">
        Confirm
      </button>
    </div>
  </div>
</div>
<div *ngIf="showHowToUseModal" class="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-[60] p-4">

  <div class="relative w-full max-w-4xl mx-auto flex flex-col items-center">
    <button (click)="showHowToUseModal = false"
      class="absolute -top-12 right-0 sm:-right-8 p-2 text-white hover:text-gray-300 transition-colors focus:outline-none"
      aria-label="Close">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
        stroke-linejoin="round" class="w-8 h-8">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="bg-white p-2 rounded-lg shadow-2xl w-full">
      <img src="../../../../assets/icons/how-to-use.png" alt="How to use guide"
        class="w-full h-auto rounded object-contain max-h-[80vh]" onerror="this.src='assets/placeholder.png'" />
    </div>
  </div>
</div>
<div *ngIf="showQuickTourModal" 
  class="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-[60] p-4">
  
  <div class="relative w-full max-w-4xl mx-auto flex flex-col items-center">
    <button (click)="showQuickTourModal = false" 
      class="absolute -top-12 right-0 sm:-right-8 p-2 text-white hover:text-gray-300 transition-colors focus:outline-none"
      aria-label="Close">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-8 h-8">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="bg-black p-2 rounded-lg shadow-2xl w-full flex justify-center">
      <video controls autoplay class="w-full h-auto rounded max-h-[80vh]">
        <source src="../../../../assets/video/quick-tour.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</div>

<!-- Session Expired Modal -->
<div *ngIf="showSessionExpiredModal" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
  <div class="bg-white p-6 rounded-lg shadow-xl text-center w-full max-w-sm mx-4">
    <p class="text-[#1d2530] font-semibold mb-6 text-[14px] sm:text-[16px] leading-relaxed">
      Session expired. You have reached the maximum of 10 queries for this session.
    </p>
    <div class="flex justify-center gap-4">
      <button (click)="resetSession()"
        class="bg-purple text-white px-6 py-2 rounded-md hover:bg-purple/90 transition-colors text-sm font-medium">
        OK
      </button>
    </div>
  </div>
</div>